<div class="card">
  <div class="card-header">
    <h6 class="surtitle">{{ chartTitle }}</h6>
  </div>
  <div class="card-body">
    <div class="chart">
      <canvas class="chart-canvas" id="chart-bar-stacked"> </canvas>
    </div>
  </div>
</div>
